
export function setBaseLayerVisibility(virtualLayers, clickedVirtualLayer, setLayerVisibility) {
    virtualLayers.forEach(layer => {
        if (layer.base) {
            let visible = (layer.id === clickedVirtualLayer.id);
            setLayerVisibility(layer.id, visible);
        }
    })
}

export function setOverLayerVisibility(virtualLayers, clickedVirtualLayer, setLayerVisibility) {
    let visible = !clickedVirtualLayer.visible;
    if (clickedVirtualLayer.group && visible) {
        virtualLayers.forEach(layer => {
            if (!layer.base) {
                if (layer.group === clickedVirtualLayer.group) {
                    setLayerVisibility(layer.id, (layer.id === clickedVirtualLayer.id));
                }
            }
        });
    } else {
        setLayerVisibility(clickedVirtualLayer.id, visible);
    }
}

